module.exports = __webpack_public_path__ + "static/media/aportesPropiosBenito.d9c43699.mp3";